(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("axios"), require("n3"), require("jose"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "axios", "n3", "jose"], factory);
	else if(typeof exports === 'object')
		exports["SharedComponents"] = factory(require("vue"), require("axios"), require("n3"), require("jose"));
	else
		root["SharedComponents"] = factory(root["vue"], root["axios"], root["n3"], root["jose"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__380__, __WEBPACK_EXTERNAL_MODULE__742__, __WEBPACK_EXTERNAL_MODULE__907__, __WEBPACK_EXTERNAL_MODULE__603__) {
return 